import { render, staticRenderFns } from "./ProductAmountModeSection.vue?vue&type=template&id=bfd73f48&scoped=true&"
import script from "./ProductAmountModeSection.vue?vue&type=script&lang=ts&"
export * from "./ProductAmountModeSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAmountModeSection.vue?vue&type=style&index=0&id=bfd73f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd73f48",
  null
  
)

export default component.exports